import React, {
  Fragment, memo, useEffect, useState,
} from 'react'
import Box from '@mui/material/Box'
import ListItemText from '@mui/material/ListItemText'
import { IconButton, LinearProgress } from '@mui/material'
import Grid from '@mui/material/Grid2'
import ArrowBackIos from '@mui/icons-material/ArrowBackIos'
import StepValid from 'components/icons/form-check.svg'
import clsx from 'clsx'
import { useRouter } from 'next/router'
import sx from './styles'

const SimplifiedTopBar = (props) => {
  const {
    items = [],
    activeStep,
    activeToBack,
    checkedCurrent = false,
    onBackPress = null,
  } = props
  const [progress, setProgress] = useState(0)
  const router = useRouter()
  const handleBackButton = () => (onBackPress ? onBackPress() : router.back())
  const valueActived = items.find((item) => item.title.toLowerCase() === activeStep.toLowerCase())
    ?.value || 1

  useEffect(() => {
    const totalItems = items.length
    if (totalItems > 0) {
      setProgress((valueActived / totalItems) * 100)
    } else {
      setProgress((1 / totalItems) * 100)
    }
  }, [activeStep])

  return (
    <Grid container>
      <Grid
        size={12}
        sx={sx.summaryList}
      >
        {items && items.map((item, index) => {
          const isChecked = checkedCurrent ? valueActived >= item.value : valueActived > item.value
          const isActive = index === 0 ? valueActived > item.value : valueActived >= item.value
          return (
            <Fragment key={index}>
              {activeToBack && (items.length !== index + 1) && (
                <IconButton
                  sx={sx.backButton}
                  size="small"
                  variant="text"
                  color="primary"
                  onClick={handleBackButton}
                >
                  <ArrowBackIos />
                </IconButton>
              )}
              <ListItemText
                sx={sx.summaryListItem}
                secondary={item.title}
                className={clsx({ active: isActive || index === 0 })}
              />
              {isChecked && (<StepValid />)}
            </Fragment>
          )
        })}
      </Grid>
      <Grid
        size={12}
        sx={sx.progressContainer}
      >
        <Box sx={sx.linearProgressWrapper}>
          <LinearProgress
            sx={sx.linearProgress}
            variant="determinate"
            value={progress}
          />
        </Box>
      </Grid>
    </Grid>
  )
}

export default memo(SimplifiedTopBar)
